import { keyframes } from '@emotion/core';

export const feverShake = keyframes`
    10%, 90% {
        transform: translate3d(-1px, 0, 0)
    }
    20%, 80% {
        transform: translate3d(2px, 0, 0)
    }
    30%, 50%, 70% {
        transform: translate3d(-4px, 0, 0)
    }
    40%, 60% {
        transform: translate3d(4px, 0, 0)
    }
`;

export const feverBlink = keyframes`
    from, 20%, 60%, 90% {
        opacity: 0;
    }
    10%, 50%, 70%, to {
        opacity: 1;
    }
`;

export const feverZoomIn = keyframes`
    from {
        transform: scale(0);
        opacity: 0;
    }
    50% {
        transform: scale(1.05);
    }
    75% {
        transform: scale(0.95);
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
`;

export const feverZoomScale = keyframes`
    0% {
        transform: scale(1);
    }
    16.6% {
        transform: scale(1.05);
    }
    33.2% {
        transform: scale(1);
    }
    49.8% {
        transform: scale(1.05);
    }
    66.4% {
        transform: scale(1);
    }
    83.0% {
        transform: scale(1.05);
    }
`;

export const feverSpin = keyframes`
    from {
        transform: rotate(0);
    }
    to{
        transform: rotate(359deg);
    }
`;
